<div class="grid ">
    <div class="col-12">
        <div class="card">
            <h4>Editar Usuário</h4>
            <form #form="ngForm" name="form" novalidate (ngSubmit)="atualizar(form)">
                <div class="p-fluid p-formgrid grid" *ngIf="loadingUsuario">
                    <div class="field col-12 md:col-12">
                        <p-divider></p-divider>
                    </div>
                </div>
                <div class="flex justify-content-center" *ngIf="loadingUsuario">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="formgroup" *ngIf="usuario">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>

                        <div class="field col-12 md:col-4">
                            <label htmlFor="nome">Nome</label>
                            <input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
                                placeholder="Digite o nome" name="nome" ngModel [(ngModel)]="usuario.nome"
                                #nome="ngModel" required />
                            <div *ngIf="nome.hasError('required') && nome.touched" class="alerta">
                                <small>Campo obrigatório</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="apelido">Apelido</label>
                            <input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
                                placeholder="Digite o apelido" name="apelido" ngModel [(ngModel)]="usuario.apelido"
                                #apelido="ngModel" />

                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="whatsapp">Whatsapp</label>
                            <p-inputMask mask="(99)99999-9999" [unmask]="true" type="text" placeholder="(99)99999-9999"
                                name="whatsapp" ngModel #whatsapp="ngModel" [(ngModel)]="usuario.whatsapp">
                            </p-inputMask>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="cpf">CPF</label>
                            <p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
                                name="cpf" ngModel #cpf="ngModel" [(ngModel)]="usuario.cpf"> </p-inputMask>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <input type="email" pInputText placeholder="nome@mail.com" name="email" ngModel
                                #email="ngModel" required email [(ngModel)]="usuario.email" />
                            <div *ngIf="email.hasError('required') && email.touched" class="alerta">
                                <small>Campo obrigatório</small>
                            </div>
                            <div *ngIf="email.hasError('email')" class="alerta">
                                <small>Digite um e-mail válido</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="tipo">Tipo</label>
                            <p-dropdown [options]="tipos" [filter]="true" emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione" name="tipo" ngModel #grupo="ngModel" [required]="true"
                                [(ngModel)]="usuario.tipo">
                            </p-dropdown>
                        </div>

                    </div>
                    <div class="p-fluid p-formgrid grid">

                        <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
                            <button type="submit" pButton icon="pi pi-check" label="Atualizar"
                                class="p-button-success mt-5" [disabled]="!form.valid"></button>
                        </div>
                        <div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
                            <button type="button" pButton icon="pi pi-spin pi-spinner" label="Processando..."
                                class="p-button-success mt-5" [disabled]="true"></button>
                        </div>
                        <div class="field col-12 md:col-8">

                        </div>
                        <div class="field col-12 md:col-2">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-primary mt-5" routerLink="/rfarias/usuario"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>